import { render, staticRenderFns } from "./RedeemTheme.vue?vue&type=template&id=af762578"
import script from "./RedeemTheme.vue?vue&type=script&lang=js"
export * from "./RedeemTheme.vue?vue&type=script&lang=js"
import style0 from "./RedeemTheme.vue?vue&type=style&index=0&id=af762578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports